import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=c12f1536&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=ts&"
export * from "./InputTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=c12f1536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12f1536",
  null
  
)

export default component.exports